import React from 'react';
import { CountdownInline } from './CountdownInline';
export function TopBar() {
  return <div className="w-full bg-ink px-6 py-2" data-id="element-240" data-mp="232dql1n7rquv">
      <p className="text-center text-[11px] font-medium text-white/80 sm:text-xs" data-id="element-241" data-mp="231c5e4chhnzf">
        La oferta de lanzamiento cierra en <CountdownInline data-id="element-242" data-mp="1y5wt3gu4k054" />
      </p>
    </div>;
}